
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.117 1.867c-.594.766-.89 1.784-.89 3.055 0 1.49.367 2.61 1.101 3.36-.557-.235-1-.66-1.328-1.274C.672 6.398.508 5.71.508 4.945c0-.526.086-1.01.258-1.453.161-.437.354-.778.578-1.023.208-.235.466-.435.773-.602zm6.5 5.438h.156l-.25 1.32c-.484.188-.95.326-1.398.414-.448.089-.88.133-1.297.133-1.26 0-2.247-.367-2.96-1.102-.714-.729-1.071-1.789-1.071-3.18 0-1.385.383-2.445 1.148-3.18C3.705.983 4.711.618 5.961.618c.906 0 1.823.164 2.75.492a31.035 31.035 0 00-.063 1.164c0 .11.003.217.008.32v.188c0 .271-.013.529-.039.774h-.133c-.323-1.573-1.224-2.36-2.703-2.36-1 0-1.797.326-2.39.977-.594.646-.891 1.578-.891 2.797 0 1.067.273 1.935.82 2.601.542.667 1.36 1 2.453 1 .605 0 1.157-.12 1.657-.36.494-.228.89-.53 1.187-.905z","fill":"currentColor"}})])
          )
        }
      }
    